/**
 * Reistijd-maximalisering per klant (A1) + de activering op de factuur
 * (batch-68 controle, FO-343 §4.2).
 *
 * De maxima (per rit en per dag, in km en minuten) stonden al op de klant maar
 * hadden geen lezer. Sinds batch-68 past de afsprakenmotor ze toe op de factuur,
 * maar pas na expliciete activering: `maximaToepassen` (default uit) en optioneel
 * `maximaToepassenVanaf` (werkdagen vanaf die datum). Zonder activering factureert
 * elke klant byte-gelijk aan voorheen. Eén schema voor de API en het formulier.
 */
import { z } from 'zod'

const ymd = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Kies een datum')

export const reistijdInstellingSchema = z.object({
  maxKmEnkel: z.number().int().min(0, 'Minimaal 0').nullable().optional(),
  maxMinEnkel: z.number().int().min(0, 'Minimaal 0').nullable().optional(),
  maxKmDag: z.number().int().min(0, 'Minimaal 0').nullable().optional(),
  maxMinDag: z.number().int().min(0, 'Minimaal 0').nullable().optional(),
  /** De maxima toepassen op de factuur (default uit). */
  maximaToepassen: z.boolean().optional(),
  /** Vanaf welke werkdag (yyyy-MM-dd); null = alle nog te factureren dagen. */
  maximaToepassenVanaf: ymd.nullable().optional(),
  /** batch-68 (FO-343 §4.7): optionele reden voor de audit van de wijziging. */
  reden: z.string().max(500).nullable().optional(),
})
export type ReistijdInstellingInput = z.infer<typeof reistijdInstellingSchema>

export interface ReistijdInstellingDTO {
  maxKmEnkel: number | null
  maxMinEnkel: number | null
  maxKmDag: number | null
  maxMinDag: number | null
  maximaToepassen: boolean
  maximaToepassenVanaf: string | null
}
